import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${(props) => props.theme.colors.greys.lighter};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 24px;

  padding: 24px 0;
`;

export const DropdownContainer = styled.div`
  display: flex;
  column-gap: 24px;
`;

export const DropdownItem = styled.div`
  width: 100%;
  max-height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const DropdownIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;
